import * as React from 'react';

type Props = {
  className?: string
}

export default ({ className }: Props) => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          className={className}
        >
          <path d="M18.667 0c-.736 0-1.334.597-1.334 1.333v12c0 .736.598 1.334 1.334 1.334h12c.736 0 1.333-.598 1.333-1.334C32 5.981 26.018 0 18.667 0zM20 12V2.75c4.818.603 8.647 4.433 9.25 9.25H20z"></path>
          <path d="M13.333 5.333C5.981 5.333 0 11.315 0 18.667 0 26.018 5.981 32 13.333 32s13.334-5.982 13.334-13.333c0-.736-.598-1.334-1.334-1.334H14.667V6.667c0-.736-.598-1.334-1.334-1.334zM23.907 20c-.659 5.253-5.144 9.333-10.574 9.333-5.88 0-10.666-4.785-10.666-10.666 0-5.43 4.08-9.915 9.333-10.574v10.574c0 .736.597 1.333 1.333 1.333h10.574z"></path>
        </svg>
    );
};